export default "__VITE_ASSET__e81dbdf3__"